import { fetchPgArticleDetail, fetchTgArticleDetail } from '~/features/catalog/article.server';
import { optionalProtectedResourceLoader } from '~/shell/utils/authUtil.server';
import invariant from 'tiny-invariant';
import { useFetcher } from 'react-router';
import { useBasePath } from '~/common/hooks/useBasePath';
import { useEffect, useMemo } from 'react';
import { getSelectedLocation } from '~/shell/utils/locationUtil.server';
import type { BghArticleDetail } from '~/common/types/bghArticleDetail';
import { TgArea } from '~/common/types/area';

export const loader = optionalProtectedResourceLoader(async ({ t, params, request, loginInfo, api }) => {
  const isTgArea = params.area === TgArea;
  const articleNumber = params.articleNumber;

  invariant(articleNumber, 'Expected articleNumber');

  const actionExclude = loginInfo?.actionExclude ?? false;
  const hasIndividualOrderEndTimes = loginInfo?.hasIndividualOrderEndTimes ?? false;
  const ccId = await getSelectedLocation(request);

  const article = isTgArea
    ? await fetchTgArticleDetail(api, articleNumber, actionExclude, hasIndividualOrderEndTimes, t)
    : await fetchPgArticleDetail(api, articleNumber, ccId, t);

  return { article };
});

export function useArticleDetail(articleNumber: string) {
  const { load, data, state } = useFetcher<typeof loader>();
  const { path } = useBasePath();

  useEffect(() => {
    load(`${path}/resources/articles/${articleNumber}/detail`);
  }, [load, articleNumber, path]);

  const isLoading = useMemo(() => state === 'loading', [state]);

  return {
    isLoading,
    article: data?.article as BghArticleDetail
  };
}
